class Wishlist {
  constructor() {
    const wishlistKey = `${window.shopName}-wishlist`;

    this.wishlistItems = localStorage.getItem(wishlistKey)
      ? localStorage.getItem(wishlistKey).split(",")
      : [];

    this.updateWishlistButtons();
    this.updateWishlistCount();

    document.addEventListener("wishlist:add", (event) => {
      this.addWishlistItem(event.detail.handle);
      this.updateWishlistCount();
    });
    document.addEventListener("wishlist:remove", (event) => {
      this.removeWishlistItem(event.detail.handle);
      this.updateWishlistCount();
    });
  }

  addWishlistItem(productHandle) {
    if (!this.wishlistItems.includes(productHandle)) {
      this.wishlistItems.push(productHandle);
      localStorage.setItem(
        `${window.shopName}-wishlist`,
        this.wishlistItems.join(",")
      );
    }
  }

  removeWishlistItem(productHandle) {
    this.wishlistItems = this.wishlistItems.filter(
      (itm) => itm !== productHandle
    );

    localStorage.setItem(
      `${window.shopName}-wishlist`,
      this.wishlistItems.join(",")
    );
  }

  updateWishlistButtons() {
    const wishlistButtons = document.querySelectorAll("wishlist-button");

    wishlistButtons.forEach((button) => {
      const productHandle = button.getAttribute("product-handle");

      if (this.wishlistItems.includes(productHandle)) {
        button.setAttribute("active", true);
      } else {
        button.removeAttribute("active");
      }
    });
  }

  updateWishlistCount() {
    const wishlistCount = document.querySelector("[wishlist-count]");

    if (!wishlistCount) return;

    if (!this.wishlistItems.length) {
      wishlistCount.classList.add("hidden");
    } else {
      wishlistCount.textContent = this.wishlistItems.length;
      wishlistCount.classList.remove("hidden");
    }
  }
}

const wishlist = new Wishlist();

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.getAttribute("product-handle");

    this.addEventListener("click", () => {
      if (this.getAttribute("active")) {
        document.dispatchEvent(
          new CustomEvent("wishlist:remove", {
            detail: {
              handle: this.productHandle,
            },
          })
        );
        this.removeAttribute("active");
      } else {
        document.dispatchEvent(
          new CustomEvent("wishlist:add", {
            detail: {
              handle: this.productHandle,
            },
          })
        );
        this.setAttribute("active", true);
      }
    });
  }
}

customElements.define("wishlist-button", WishlistButton);

class MainWishlist extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      wishlistEmpty: ".wishlist-empty",
      productsList: ".wishlist-products-list",
    };

    this.fetchWishlistProducts();
  }

  async fetchWishlistProductsMarkup(handle) {
    const response = await fetch(
      // `/products/${handle}?view=wishlist-card&section_id=card-product-wishlist`
      `/products/${handle}?view=wishlist-card&section_id=card-product-wishlist`
    );
    const product = await response.text();
    return product;
  }

  async fetchWishlistProducts() {
    const wishlistEmpty = this.querySelector(this.selectors.wishlistEmpty);
    const productsList = this.querySelector(this.selectors.productsList);

    if (wishlist.wishlistItems.length > 0) {
      wishlistEmpty.style.display = "none";
    }

    if (wishlist.wishlistItems.length === 0) {
      wishlistEmpty.style.display = "block";
      productsList.style.display = "none";
      return;
    }

    let buildProductListItems = [];

    for (let index = 0; index < wishlist.wishlistItems.length; index++) {
      const handle = wishlist.wishlistItems[index];
      const productMarkup = await this.fetchWishlistProductsMarkup(handle);
      buildProductListItems.push(productMarkup);
    }

    console.log(buildProductListItems);
    // return;
    productsList.insertAdjacentHTML(
      "afterbegin",
      buildProductListItems.join("")
    );

    productsList.classList.add("loaded");
    wishlistEmpty.style.display = "none";
  }
}

customElements.define("main-wishlist", MainWishlist);
